import {
  Injectable,
  OnDestroy
} from '@angular/core';
import { Subscription } from 'rxjs';
import { FormsSources } from './forms-sources';
import { Store } from '@ngrx/store';
import { NGXLogger } from 'ngx-logger';

@Injectable()
export class FormsRunner implements OnDestroy {
  private formsSubscription: Subscription | null = null;

  constructor(
    private formSources: FormsSources,
    private store: Store<any>,
    private logger: NGXLogger
  ) {}

  start() {
    this.logger.trace('[FormsRunner::start] call');
    if (!this.formsSubscription) {
      this.formsSubscription = this.formSources
        .toActions()
        .subscribe(this.store);
    }
  }

  ngOnDestroy() {
    this.logger.trace('[FormsRunner::ngOnDestroy] call');
    if (this.formsSubscription) {
      this.formsSubscription.unsubscribe();
      this.formsSubscription = null;
    }
  }
}
